import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  roles: [],
  permissions: []
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
    state.permissions = user.permissions
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.roles = null
    state.permissions = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/me?verify=true')

      commit(types.FETCH_USER_SUCCESS, { user: data })
      return true
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
      return false
    }
  },

  async updateEventNotif ({ commit }, payload) {
    const uri_notif_mail = '/api/send-notif'
    const objet = {}
    objet.id = payload

    axios.put(uri_notif_mail, objet)
      .then(response => {
      })
      .catch(err => { console.log('Erreur mise à jour notif ', err) })
  },

  async updateUser ({ commit }, payload) {
    const config = { headers: { 'content-type': 'multipart/form-data' }}

    /* const uri_delete = '/api/users/'+payload.id;
    await axios.delete(uri_delete)
        .then(response => { })
        .catch(err => { console.log('Delete user profile error ', err) })*/

    const uri = '/api/me/?verify=true'

    const objet = new FormData()
    objet.append('id', payload.id)
    objet.append('avatar_url', payload.avatar_url)
    objet.append('first_name', payload.first_name)
    objet.append('last_name', payload.last_name)
    objet.append('username', payload.username)
    objet.append('phone', payload.phone)
    objet.append('address', payload.address)
    objet.append('country_id', payload.country_id)
    objet.append('department_id', payload.department_id)
    objet.append('municipality_id', payload.municipality_id)
    objet.append('district_id', payload.district_id)
    objet.append('password', payload.password)

    axios.put(uri, payload)
        .then(response => { commit(types.UPDATE_USER, response.data) })
        .catch(err => { console.log('Update user error ', err) })
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  }
}

// getters
export const getters = {
  authUser: state => state.user,
  authToken: state => state.token,
  authCheck: state => state.user !== null,
  roles: state => state.user.user.roles,
  permissions: state => state.permissions
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js